import { formatNumber } from '../helpers'

export function restrictInput(e: React.KeyboardEvent<HTMLInputElement>) {
    const allowedChars = /[0-9]/
    const currentValue = e.currentTarget.value
    const allowedShortcutCodes = ['KeyC', 'KeyV', 'KeyX', 'KeyA', 'KeyZ', 'KeyY']

    if ((e.ctrlKey || e.metaKey) && allowedShortcutCodes.includes(e.code)) {
        return
    }

    if (allowedChars.test(e.key) || e.key === 'Backspace' || e.key === 'Delete') {
        return
    }
    if (
        (e.key === '.' || e.key === ',') &&
        !currentValue.includes('.') &&
        !currentValue.includes(',')
    ) {
        return
    }

    e.preventDefault()
}

export { formatNumber }
